import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'
import { globalState } from '@/components/helpers/utils'

const storefrontLink = createHttpLink({
  uri: globalState.apis.graphQlEndpoint,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Shopify-Storefront-Access-Token': globalState.apis.storefrontAccessToken
  }
})

export const storefront = new ApolloClient({
  link: storefrontLink,
  cache: new InMemoryCache()
})
